import { render, staticRenderFns } from "./ShowPage.vue?vue&type=template&id=e9331c74&scoped=true&lang=pug&"
import script from "./ShowPage.vue?vue&type=script&lang=js&"
export * from "./ShowPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowPage.vue?vue&type=style&index=0&id=e9331c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9331c74",
  null
  
)

export default component.exports